/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useCallback,
  useContext,
  useMemo,
  useEffect
} from 'react';
import { Col } from '@thd-olt-component-react/grid';
import {
  arrayOf,
  string,
  shape,
  func,
  bool
} from 'prop-types';
import { LayoutGroup } from '@thd-olt-component-react/layout-manager';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Carousel } from '@thd-olt-component-react/carousel';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import classNames from 'classnames';
import { CategoryFilter } from './CategoryFilter';

export const SingleIRG = ({
  tab,
  onClickCategory,
  onClickNext,
  onError,
  accordion,
  showMobileCardTabs
}) => {

  let IRG;
  const [cardOverlayContents, setCardOverlayContents] = useState(null);
  let cardOverlayRef = useCallback((node) => {
    if (node !== null) {
      setCardOverlayContents(node);
    }
  }, [cardOverlayContents]);

  const {
    channel,
  } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const limit = isMobile ? 2 : 6;

  const [selectedItem, setSelectedItem] = useState(0);
  const showArrowsValue = true;

  const irgFilterClass = classNames(
    'item-related-groups__filters',
    { 'item-related-groups__filters--mobile': (channel === 'mobile') }
  );

  const { categories, hasSubcategories } = tab;

  // @todo i dont like how active is stored inside the data reducer state
  // it should probably be part of this components state
  let activeTab = tab.categories?.find((_tab) => _tab.active);

  activeTab = activeTab || tab;

  useEffect(() => {
    let throttleTimeout = null;
    const overlayElement = cardOverlayContents?.parentElement?.parentElement;

    const handleScroll = () => {
      if (throttleTimeout === null
        && overlayElement.scrollHeight - overlayElement.scrollTop === overlayElement.clientHeight) {
        throttleTimeout = setTimeout(() => {
          onClickNext({
            tab: activeTab,
            limit: limit + 2,
            start: activeTab.visibleItemIds.length + 4
          });
          setSelectedItem(activeTab.visibleItemIds.length + 4);
        }, 500);
      }
    };
    if (overlayElement) {
      overlayElement.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (overlayElement) {
        overlayElement.removeEventListener('scroll', handleScroll);
      }
      if (throttleTimeout) {
        clearTimeout(throttleTimeout);
        throttleTimeout = null;
      }
    };
  }, [cardOverlayContents?.children?.length]);

  const _onClickCategory = useCallback(({ category }) => {
    onClickCategory({
      tab,
      category,
      start: 9
    });
    setSelectedItem(0);
  }, [tab?.name]);

  const handleError = (itemId, { data, loading, error }) => {
    if (!data?.model?.product?.itemId) {
      onError(itemId);
    }
  };

  let subCategories = useMemo(() => (
    hasSubcategories
    && (
      <div className={irgFilterClass}>
        <>
          {categories?.map((catgory, index) => (
            <CategoryFilter
              key={index}
              category={catgory}
              onClick={_onClickCategory}
              showMobileCardTabs={showMobileCardTabs}
            />
          ))}
        </>
      </div>
    ))
  );

  const CarouselIRG = () => {
    return (
      <>
        {subCategories}
        <Carousel
          name={`single-irg-${activeTab.name}`}
          itemClass="fixed-item"
          showArrows={showArrowsValue}
          multiItem={false}
          fixedItem
          disableSwipeNavigation={false}
          totalItems={activeTab.itemIds.length}
          selectedItem={selectedItem}
          onNextClick={() => {
            onClickNext({
              tab: activeTab,
              limit,
              start: selectedItem + limit
            });
            setSelectedItem(selectedItem + limit);
          }}
          onPrevClick={() => {
            if (selectedItem > 0) {
              // @todo more logic around this, seems flaky
              setSelectedItem(Math.max(selectedItem - limit, 0));
            }
          }}

        >
          {(activeTab.visibleItemIds || []).map((itemId, index) => {
            return (
              <LayoutGroup key={index} name={`product-pod-${index}`}>
                <ProductPod
                  brandMaxLine={1}
                  itemId={itemId}
                  storeId={tab.storeId}
                  titleMaxLine={2}
                  hideShippingInfo
                  mobilePodType="doubleColumn"
                  onError={(resp = {}) => handleError(itemId, resp)}
                  showFavoritesCount
                  showDisabledATC
                  position={index}
                  noATCFulfillment
                />
              </LayoutGroup>
            );
          })}
        </Carousel>
      </>
    );
  };

  const MobileCardIRG = () => {
    return (
      <div className="grid" ref={cardOverlayRef}>
        {showMobileCardTabs && subCategories}
        {
          (activeTab.visibleItemIds || []).map((itemId, index) => {
            return (
              <LayoutGroup key={index} name={`product-pod-${index}`}>
                <Col lg="3" md="3" sm="3" xs="4" fallback="6" className="item-related-groups__mobile-card__pod">
                  <ProductPod
                    brandMaxLine={1}
                    itemId={itemId}
                    storeId={tab.storeId}
                    titleMaxLine={2}
                    hideShippingInfo
                    mobilePodType="doubleColumn"
                    onError={(resp = {}) => handleError(itemId, resp)}
                    showFavoritesCount
                    showDisabledATC
                    position={index}
                    hover
                    noATCFulfillment
                  />
                </Col>
              </LayoutGroup>
            );
          })
        }
      </div>
    );
  };

  if (channel !== 'mobile' || (channel === 'mobile' && !accordion)) {
    IRG = CarouselIRG();
  } else if (channel === 'mobile' && tab) {
    IRG = MobileCardIRG();
  }

  return IRG;
};

SingleIRG.propTypes = {
  tab: shape({
    visibleItems: arrayOf(string),
    itemIds: arrayOf(string)
  }).isRequired,
  onClickCategory: func,
  onClickNext: func,
  onError: func,
  accordion: bool,
  showMobileCardTabs: bool
};

const NOOP = () => {
};

SingleIRG.defaultProps = {
  onClickCategory: NOOP,
  onClickNext: NOOP,
  onError: NOOP,
  accordion: false,
  showMobileCardTabs: false
};
